// import React, { useEffect, useRef, useState } from 'react';
// import {
//   Card,
//   CardTitle,
//   CardBody,
//   Button,
//   Table,
//   Input,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Form,
//   FormGroup,
//   Label,
//   FormText,
// } from 'reactstrap';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { useSelector } from 'react-redux';
// import useVendorBranch from '../../utils/useVendorBranch';
// import conditionalDataLoad from '../../utils/conditionalDataLoad';
// import { toast } from 'react-toastify';
// import {
//   createAppConnection,
//   joinModuleGroup,
//   leaveModuleGroup,
//   subscribeRealtimeUpdate,
//   unsubscribeRealtimeUpdate,
// } from '../../utils/signalRService';

// const MODULE_NAME = 'Faculty';

// const getRowId = (row) =>
//   Number(row?.faculty_id ?? row?.faculty_id ?? row?.id ?? 0);

// const FacultyMaster = () => {
//   const { user } = useSelector((state) => state.authState);
//   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
//     useVendorBranch(user);

//   const [selectionData, setSelectionData] = useState({
//     vendor_id: '',
//     branch_id: '',
//   });
//   const [errorMessage, setErrorMessage] = useState({});
//   const [facultyTable, setFacultyTable] = useState([]);
//   const [searchText, setSearchText] = useState('');

//   const navigate = useNavigate();

//   const [showModal, setShowModal] = useState(false);
//   const [file, setFile] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [showDynamicModal, setShowDynamicModal] = useState(false);
//   const [dynamicFile, setDynamicFile] = useState(null);
//   const [dynamicLoading, setDynamicLoading] = useState(false);

//   const currentGroupRef = useRef({
//     module: null,
//     vendorId: null,
//     branchId: null,
//   });

//   const onHandleAdd = () => {
//     navigate('/save-faculty');
//   };

//   const onHandleEdit = (row) => {
//     if (!row) return;

//     const id = getRowId(row);
//     if (!id) {
//       toast.error('Invalid faculty id in row data');
//       return;
//     }

//     navigate('/save-faculty', { state: { ...row, id } });
//   };

//   const GetFaculty = async (search = '') => {
//     const vendorId = selectionData.vendor_id || '';
//     const branchId = selectionData.branch_id || '';

//     try {
//       const response = await apiService.get(
//         `api/FacultyMaster/GetAllFaculty?vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(
//           search,
//         )}`,
//       );

//       if (response?.status === true) {
//         setFacultyTable(response?.data || response?.Data || []);
//       } else {
//         setFacultyTable([]);
//         console.error(response?.message || 'Failed to fetch');
//       }
//     } catch (err) {
//       console.error(err);
//       setFacultyTable([]);
//       toast.error('Failed to fetch faculty list');
//     }
//   };

//   const onHandleSearch = (e) => {
//     const value = e.target.value;
//     setSearchText(value);
//     GetFaculty(value);
//   };

//   const onHandleDelete = async (row) => {
//     const faculty_id = getRowId(row);

//     if (!faculty_id) {
//       toast.error('Invalid faculty id');
//       return;
//     }

//     const ok = window.confirm('Are you sure you want to delete this faculty?');
//     if (!ok) return;

//     try {
//       const res = await apiService.delete(
//         `api/FacultyMaster/DeleteFaculty?id=${faculty_id}`,
//       );

//       if (res?.status === true) {
//         toast.success(res.message || 'Deleted successfully');
//         GetFaculty(searchText);
//       } else {
//         toast.error(res?.message || 'Delete failed');
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error('Something went wrong while deleting');
//     }
//   };

//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: selectionData.vendor_id,
//       branchId: selectionData.branch_id,
//     });

//     if (canLoad) {
//       GetFaculty(searchText);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectionData.vendor_id, selectionData.branch_id]);

//   useEffect(() => {
//     let mounted = true;

//     const setupSignalR = async () => {
//       try {
//         await createAppConnection();

//         const vendorId = selectionData.vendor_id || 0;
//         const branchId = selectionData.branch_id || 0;

//         const prev = currentGroupRef.current;

//         if (
//           prev.vendorId &&
//           prev.branchId &&
//           (String(prev.vendorId) !== String(vendorId) ||
//             String(prev.branchId) !== String(branchId))
//         ) {
//           await leaveModuleGroup(prev.module, prev.vendorId, prev.branchId);
//         }

//         if (vendorId && branchId) {
//           await joinModuleGroup(MODULE_NAME, vendorId, branchId);

//           currentGroupRef.current = {
//             module: MODULE_NAME,
//             vendorId,
//             branchId,
//           };
//         }

//         unsubscribeRealtimeUpdate();

//         await subscribeRealtimeUpdate((payload) => {
//           if (!mounted || !payload) return;

//           const isSameModule = String(payload.module || '') === MODULE_NAME;
//           const isSameVendor =
//             String(payload.vendorId || '') === String(vendorId || '');
//           const isSameBranch =
//             String(payload.branchId || '') === String(branchId || '');

//           if (isSameModule && isSameVendor && isSameBranch) {
//             GetFaculty(searchText);
//           }
//         });
//       } catch (err) {
//         console.error('SignalR error:', err);
//       }
//     };

//     setupSignalR();

//     return () => {
//       mounted = false;
//     };
//   }, [selectionData.vendor_id, selectionData.branch_id, searchText]);

//   useEffect(() => {
//     return () => {
//       unsubscribeRealtimeUpdate();

//       const prev = currentGroupRef.current;
//       if (prev?.vendorId && prev?.branchId) {
//         leaveModuleGroup(prev.module, prev.vendorId, prev.branchId).catch(
//           console.error,
//         );
//       }
//     };
//   }, []);

//   const openModal = () => {
//     setFile(null);
//     setShowModal(true);
//   };

//   const toggle = () => setShowModal(!showModal);

//   const handleFileChange = (e) => {
//     setFile(e.target.files?.[0] || null);
//   };

//   const handleSubmit = async () => {
//     if (!file) {
//       toast.error('Please select an Excel file');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', file);

//     try {
//       setLoading(true);

//       const res = await apiService.post(
//         `api/FacultyMaster/bulk-import-excel?vendorId=${selectionData.vendor_id}&branchId=${selectionData.branch_id}`,
//         formData,
//         { headers: { 'Content-Type': 'multipart/form-data' } },
//       );

//       if (res?.status) {
//         toast.success(res.message || 'Imported successfully');
//         GetFaculty(searchText);
//       } else {
//         toast.error(res?.message || 'Import failed');
//       }
//     } catch (err) {
//       toast.error(err?.response?.data || 'Something went wrong during import');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const openDynamicModal = () => {
//     setDynamicFile(null);
//     setShowDynamicModal(true);
//   };

//   const toggleDynamic = () => setShowDynamicModal(!showDynamicModal);

//   const handleDynamicFileChange = (e) => {
//     setDynamicFile(e.target.files?.[0] || null);
//   };

//   const handleDynamicSubmit = async () => {
//     if (!dynamicFile) {
//       toast.error('Please select an Excel file');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', dynamicFile);

//     try {
//       setDynamicLoading(true);

//       const res = await apiService.post(
//         `api/FacultyMaster/raw-import-excel`,
//         formData,
//         {
//           headers: { 'Content-Type': 'multipart/form-data' },
//         },
//       );

//       if (res?.status) {
//         toast.success(res.message || 'Dynamic import successful');
//         GetFaculty(searchText);
//       } else {
//         toast.error(res?.message || 'Dynamic import failed');
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error('Dynamic import failed');
//     } finally {
//       setDynamicLoading(false);
//     }
//   };

//   const handleDownloadSample = async (e) => {
//     e?.preventDefault?.();
//     try {
//       const response = await apiService.get(
//         `/api/FacultyMaster/bulk-import-sample-excel`,
//         {
//           responseType: 'blob',
//           headers: { 'Content-Type': undefined },
//         },
//       );

//       const blobData =
//         response?.data instanceof Blob
//           ? response.data
//           : new Blob([response.data]);

//       const url = window.URL.createObjectURL(blobData);
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', 'faculty_master_import_sample.xlsx');
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error(error);
//       toast.error('Failed to download sample file');
//     }
//   };

//   return (
//     <>
//       {showModal && (
//         <Modal centered isOpen={showModal} toggle={toggle} size='lg'>
//           <ModalHeader toggle={toggle}>Bulk Import Faculty (Old)</ModalHeader>
//           <ModalBody>
//             <Form>
//               <FormGroup>
//                 <Label>Upload Excel File</Label>
//                 <Input
//                   type='file'
//                   accept='.xlsx,.xls'
//                   onChange={handleFileChange}
//                 />
//                 <FormText className='text-right'>
//                   <a href='#' onClick={handleDownloadSample}>
//                     <i className='bi bi-download mr-1'></i> Download Excel
//                     Sample format
//                   </a>
//                 </FormText>
//               </FormGroup>
//             </Form>
//           </ModalBody>

//           <ModalFooter>
//             <Button color='primary' onClick={handleSubmit} disabled={loading}>
//               {loading ? 'Importing...' : 'Submit'}
//             </Button>
//             <Button color='secondary' onClick={toggle} disabled={loading}>
//               Cancel
//             </Button>
//           </ModalFooter>
//         </Modal>
//       )}

//       {showDynamicModal && (
//         <Modal
//           centered
//           isOpen={showDynamicModal}
//           toggle={toggleDynamic}
//           size='lg'
//         >
//           <ModalHeader toggle={toggleDynamic}>
//             Dynamic Bulk Import Faculty
//           </ModalHeader>
//           <ModalBody>
//             <Form>
//               <FormGroup>
//                 <Label>Upload Excel File (Dynamic Columns Allowed)</Label>
//                 <Input
//                   type='file'
//                   accept='.xlsx,.xls'
//                   onChange={handleDynamicFileChange}
//                 />
//                 <FormText>
//                   Extra columns (x,y,z etc.) allowed. Header should be SQL-safe:
//                   <b> x_value </b> (no spaces/symbols).
//                 </FormText>

//                 <FormText className='text-right'>
//                   <a href='#' onClick={handleDownloadSample}>
//                     <i className='bi bi-download mr-1'></i> Download Sample
//                     format
//                   </a>
//                 </FormText>
//               </FormGroup>
//             </Form>
//           </ModalBody>

//           <ModalFooter>
//             <Button
//               color='primary'
//               onClick={handleDynamicSubmit}
//               disabled={dynamicLoading}
//             >
//               {dynamicLoading ? 'Importing...' : 'Submit'}
//             </Button>
//             <Button
//               color='secondary'
//               onClick={toggleDynamic}
//               disabled={dynamicLoading}
//             >
//               Cancel
//             </Button>
//           </ModalFooter>
//         </Modal>
//       )}

//       <div className='text-right mb-2'>
//         <Button color='success' className='mr-2' onClick={openModal}>
//           <i className='bi bi-file-earmark-spreadsheet mr-1'></i> Bulk Import
//           (Old)
//         </Button>

//         <Button color='warning' className='mr-2' onClick={openDynamicModal}>
//           <i className='bi bi-lightning-charge mr-1'></i> Dynamic Import
//         </Button>

//         <Button color='primary' onClick={onHandleAdd}>
//           <i className='bi bi-plus-circle' /> Add Faculty
//         </Button>
//       </div>

//       <VendorBranchSelector
//         user={user}
//         selectionData={selectionData}
//         setSelectionData={setSelectionData}
//         errorMessage={errorMessage}
//         accessButton={true}
//       />

//       <Card className='card-box height-100-p pd-20 mb-20'>
//         <CardTitle
//           tag='h6'
//           className='p-3 mb-0 d-flex align-items-center justify-content-between'
//         >
//           <div className='d-flex align-items-center'>
//             <i className='bi bi-people-fill mr-2'></i>
//             Faculty List
//           </div>
//         </CardTitle>

//         <div className='col-12 p-2'>
//           <Input
//             placeholder='Search...'
//             value={searchText}
//             onChange={onHandleSearch}
//           />
//         </div>

//         <CardBody>
//           <div className='table-responsive'>
//             <Table striped hover responsive className='admission-master-table'>
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Edit</th>
//                   <th>Faculty Code</th>
//                   <th>Faculty Name</th>
//                   <th>Mobile</th>
//                   <th>Email</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {facultyTable && facultyTable.length ? (
//                   facultyTable.map((row, i) => {
//                     const id = getRowId(row);
//                     return (
//                       <tr key={id || i}>
//                         <td>{i + 1}</td>

//                         <td width={2}>
//                           <Button
//                             color='success'
//                             size='sm'
//                             onClick={() => onHandleEdit(row)}
//                           >
//                             <i className='bi bi-pencil'></i>
//                           </Button>
//                         </td>

//                         <td>{row.faculty_code ?? row.facultyCode ?? ''}</td>
//                         <td>{row.faculty_name ?? row.faculty_name ?? ''}</td>
//                         <td>{row.mobile ?? ''}</td>
//                         <td>{row.email ?? ''}</td>

//                         <td className='text-center'>
//                           <i
//                             className='bi bi-trash text-danger'
//                             style={{ cursor: 'pointer', fontSize: '1.1rem' }}
//                             title='Delete'
//                             onClick={() => onHandleDelete(row)}
//                           />
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan={7} className='text-center'>
//                       No data available
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           </div>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default FacultyMaster;
//heena
import React, { useEffect, useRef, useState } from 'react';
import {
  Card,
  CardTitle,
  CardBody,
  Button,
  Table,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  FormText,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import { toast } from 'react-toastify';
import {
  createAppConnection,
  joinModuleGroup,
  leaveModuleGroup,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';

const MODULE_NAME = 'Faculty';

const getRowId = (row) => Number(row?.faculty_id ?? row?.id ?? 0);

const FacultyMaster = () => {
  const { user } = useSelector((state) => state.authState);
  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const [errorMessage, setErrorMessage] = useState({});
  const [facultyTable, setFacultyTable] = useState([]);
  const [searchText, setSearchText] = useState('');

  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const currentGroupRef = useRef({
    module: null,
    vendorId: null,
    branchId: null,
  });

  const onHandleAdd = () => {
    navigate('/save-faculty');
  };

  const onHandleEdit = (row) => {
    if (!row) return;

    const id = getRowId(row);

    if (!id) {
      toast.error('Invalid faculty id in row data');
      return;
    }

    navigate('/save-faculty', { state: { ...row, id } });
  };

  const GetFaculty = async (search = '') => {
    const vendorId = selectionData.vendor_id || '';
    const branchId = selectionData.branch_id || '';

    try {
      const response = await apiService.get(
        `api/FacultyMaster/GetAllFaculty?vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(
          search,
        )}`,
      );

      console.log('GET FACULTY RESPONSE:', response);

      if (response?.status === true) {
        setFacultyTable(response?.data || response?.Data || []);
      } else {
        setFacultyTable([]);
        toast.error(response?.message || response?.Message || 'Failed to fetch');
      }
    } catch (err) {
      console.error(err);
      setFacultyTable([]);
      toast.error('Failed to fetch faculty list');
    }
  };

  const onHandleSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    GetFaculty(value);
  };

  const onHandleDelete = async (row) => {
    const faculty_id = getRowId(row);

    if (!faculty_id) {
      toast.error('Invalid faculty id');
      return;
    }

    const ok = window.confirm('Are you sure you want to delete this faculty?');
    if (!ok) return;

    try {
      const res = await apiService.delete(
        `api/FacultyMaster/DeleteFaculty?id=${faculty_id}`,
      );

      if (res?.status === true) {
        toast.success(res.message || res.Message || 'Deleted successfully');
        GetFaculty(searchText);
      } else {
        toast.error(res?.message || res?.Message || 'Delete failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong while deleting');
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      GetFaculty(searchText);
    } else {
      setFacultyTable([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionData.vendor_id, selectionData.branch_id]);

  useEffect(() => {
    let mounted = true;

    const setupSignalR = async () => {
      try {
        await createAppConnection();

        const vendorId = selectionData.vendor_id || 0;
        const branchId = selectionData.branch_id || 0;

        const prev = currentGroupRef.current;

        if (
          prev.vendorId &&
          prev.branchId &&
          (String(prev.vendorId) !== String(vendorId) ||
            String(prev.branchId) !== String(branchId))
        ) {
          await leaveModuleGroup(prev.module, prev.vendorId, prev.branchId);
        }

        if (vendorId && branchId) {
          await joinModuleGroup(MODULE_NAME, vendorId, branchId);

          currentGroupRef.current = {
            module: MODULE_NAME,
            vendorId,
            branchId,
          };
        }

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate((payload) => {
          if (!mounted || !payload) return;

          const isSameModule = String(payload.module || '') === MODULE_NAME;
          const isSameVendor =
            String(payload.vendorId || '') === String(vendorId || '');
          const isSameBranch =
            String(payload.branchId || '') === String(branchId || '');

          if (isSameModule && isSameVendor && isSameBranch) {
            GetFaculty(searchText);
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      setupSignalR();
    }

    return () => {
      mounted = false;
    };
  }, [
    selectionData.vendor_id,
    selectionData.branch_id,
    searchText,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
  ]);

  useEffect(() => {
    return () => {
      unsubscribeRealtimeUpdate();

      const prev = currentGroupRef.current;

      if (prev?.vendorId && prev?.branchId) {
        leaveModuleGroup(prev.module, prev.vendorId, prev.branchId).catch(
          console.error,
        );
      }
    };
  }, []);

  const openModal = () => {
    setFile(null);
    setShowModal(true);
  };

  const toggle = () => setShowModal(!showModal);

  const handleFileChange = (e) => {
    setFile(e.target.files?.[0] || null);
  };

  const handleSubmit = async () => {
    if (!file) {
      toast.error('Please select an Excel file');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      setLoading(true);

      const res = await apiService.post(
        `api/FacultyMaster/bulk-import-excel?vendorId=${selectionData.vendor_id}&branchId=${selectionData.branch_id}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );

      if (res?.status) {
        toast.success(res.message || res.Message || 'Imported successfully');
        setShowModal(false);
        GetFaculty(searchText);
      } else {
        toast.error(res?.message || res?.Message || 'Import failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong during import');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadSample = async (e) => {
    e?.preventDefault?.();

    try {
      const response = await apiService.get(
        `/api/FacultyMaster/bulk-import-sample-excel`,
        {
          responseType: 'blob',
          headers: { 'Content-Type': undefined },
        },
      );

      const blobData =
        response?.data instanceof Blob
          ? response.data
          : new Blob([response.data]);

      const url = window.URL.createObjectURL(blobData);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'faculty_master_import_sample.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      toast.error('Failed to download sample file');
    }
  };

  return (
    <>
      {showModal && (
        <Modal centered isOpen={showModal} toggle={toggle} size='lg'>
          <ModalHeader toggle={toggle}>Bulk Import Faculty</ModalHeader>

          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Upload Excel File</Label>
                <Input
                  type='file'
                  accept='.xlsx,.xls'
                  onChange={handleFileChange}
                />

                <FormText className='text-right'>
                  <a href='#' onClick={handleDownloadSample}>
                    <i className='bi bi-download mr-1'></i> Download Excel
                    Sample format
                  </a>
                </FormText>
              </FormGroup>
            </Form>
          </ModalBody>

          <ModalFooter>
            <Button color='primary' onClick={handleSubmit} disabled={loading}>
              {loading ? 'Importing...' : 'Submit'}
            </Button>

            <Button color='secondary' onClick={toggle} disabled={loading}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )}

      <div className='text-right mb-2'>
        <Button color='success' className='mr-2' onClick={openModal}>
          <i className='bi bi-file-earmark-spreadsheet mr-1'></i> Bulk Import
        </Button>

        <Button color='primary' onClick={onHandleAdd}>
          <i className='bi bi-plus-circle' /> Add Faculty
        </Button>
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardTitle
          tag='h6'
          className='p-3 mb-0 d-flex align-items-center justify-content-between'
        >
          <div className='d-flex align-items-center'>
            <i className='bi bi-people-fill mr-2'></i>
            Faculty List
          </div>
        </CardTitle>

        <div className='col-12 p-2'>
          <Input
            placeholder='Search by name, mobile, email, code...'
            value={searchText}
            onChange={onHandleSearch}
          />
        </div>

        <CardBody>
          <div className='table-responsive'>
            <Table striped hover responsive className='admission-master-table'>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Edit</th>
                  <th>Faculty Code</th>
                  <th>Faculty Name</th>
                  <th>Designation</th>
                  <th>Salary</th>
                  <th>Leave Allowed</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {facultyTable && facultyTable.length ? (
                  facultyTable.map((row, i) => {
                    const id = getRowId(row);

                    return (
                      <tr key={id || i}>
                        <td>{i + 1}</td>

                        <td width={2}>
                          <Button
                            color='success'
                            size='sm'
                            onClick={() => onHandleEdit(row)}
                          >
                            <i className='bi bi-pencil'></i>
                          </Button>
                        </td>

                        <td>{row.faculty_code ?? row.facultyCode ?? ''}</td>
                        <td>{row.faculty_name ?? ''}</td>
                        <td>{row.designation ?? ''}</td>

                        <td>
                          {row.salary_amount !== null &&
                          row.salary_amount !== undefined
                            ? Number(row.salary_amount).toFixed(2)
                            : '0.00'}
                        </td>

                        <td>{row.leave_allowed ?? ''}</td>
                        <td>{row.mobile ?? ''}</td>
                        <td>{row.email ?? ''}</td>

                        <td className='text-center'>
                          <i
                            className='bi bi-trash text-danger'
                            style={{ cursor: 'pointer', fontSize: '1.1rem' }}
                            title='Delete'
                            onClick={() => onHandleDelete(row)}
                          />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={10} className='text-center'>
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default FacultyMaster;